import { defineComponent as _defineComponent } from 'vue'
import type { ToggleMySportsNotificationPayload } from '@/features/sports/types/enums';

import { SportEventStatus } from '@/@types/graphql-types';
import BasicButton from '@/ui-components/BasicButton.vue';

import { faBell } from '@fortawesome/free-solid-svg-icons';
import { useSportsNotification } from '@/features/sports/composables/useSportsNotification';

import { useI18n } from '@/helpers/composables/useI18n';

import { computed } from 'vue';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoOfferNotifier',
  props: {
    eventStatus: null,
    notifyMePayload: null,
    showLabel: { type: Boolean, default: true }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'click', event: Event): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { eventStatus: SportEventStatus, notifyMePayload: ToggleMySportsNotificationPayload, showLabel: boolean };





const { tc } = useI18n();
const { isLoggedIn } = storeToRefs(useUserStore());

const isNotificationActive = computed(() => props.notifyMePayload.isNotificationActive);

const endedStatus = [SportEventStatus.Ended, SportEventStatus.Closed];
const isEnded = computed(() => endedStatus.includes(props.eventStatus));

const buttonLabel = computed(() => {
	if (isEnded.value) {
		return tc('SPORTS_WEBAPP_NOTIFY_WHEN_HL_AVAIL');
	}

	return isNotificationActive.value ? tc('SPORTS_WEBAPP_NOTIFICATIONACTIVE') : tc('SPORTS_WEBAPP_NOTIFY_WHEN_AVAIL');
});

const { toggleMySportsNotification } = useSportsNotification();
async function notifyMe(event: Event) {
	if (isEnded.value) return;

	await toggleMySportsNotification(props.notifyMePayload, isLoggedIn.value);
	emit('click', event);
}

return { __sfc: true,props, emit, tc, isLoggedIn, isNotificationActive, endedStatus, isEnded, buttonLabel, toggleMySportsNotification, notifyMe, BasicButton, faBell }
}

})